var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorprateConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_634_20544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0332 22.4571H18.7042V27.4227H18.0332V22.4571Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6245 23.5978H17.2955V27.4227H16.6245V23.5978Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2148 25.8117H15.8858V27.4223H15.2148V25.8117Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7393 24.0672H14.4102V27.4223H13.7393V24.0672Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3296 25.0067H13.0005V27.4224H12.3296V25.0067Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9209 25.9461H11.5919V27.4223H10.9209V25.9461Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51123 26.7512H10.1822V27.4221H9.51123V26.7512Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9778 6.4192V22.9933H26.4884V27.0193H25.616V22.6579L23.5357 22.3224C23.3345 21.5843 23.0659 20.9134 22.6633 20.3092L23.9383 18.5647L20.7172 15.3437L18.9056 16.6856C18.3018 16.3501 17.6306 16.0818 16.9596 15.8803L16.6241 13.666H12.0611L11.7257 15.8803C11.0547 16.0815 10.4506 16.3501 9.77963 16.6856L7.90075 15.2765L4.6797 18.4976L6.02162 20.3092C5.68615 20.913 5.41783 21.5843 5.21636 22.2553L3.00202 22.5907V27.0866L0.855469 27.0869V3.73511H5.95539L7.16328 6.48641H29.9781L29.9778 6.4192Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0642 10.3115L30.7156 23.0609L30.6484 23.128V10.3118L33.0642 10.3115Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1172 25.6772H29.1729V41.1107H41.1172V25.6772ZM35.3464 39.3661H30.448V38.6952H35.3464V39.3661ZM39.9093 37.0847H30.4477V36.4137H39.9093V37.0847ZM39.9093 34.8032H30.4477V34.1322H39.9093V34.8032ZM39.9093 32.5217H30.4477V31.8507H39.9093V32.5217ZM39.9093 30.2402H30.4477V29.5693H39.9093V30.2402ZM39.9093 28.093H33.2661V27.4221H39.9093V28.093Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2261 23.7315V43.1241H43.1296V23.7315H27.2261ZM41.7876 41.7821H28.5013V25.0067H41.7876V41.7821Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9038 0.916656C27.4276 0.916656 26.2197 2.12454 26.2197 3.60074C26.2197 5.07694 27.4276 6.28482 28.9038 6.28482C30.38 6.28482 31.5879 5.07694 31.5879 3.60074C31.5879 2.0574 30.38 0.916656 28.9038 0.916656ZM28.7023 4.74148L27.4273 3.66788L27.8971 3.13093L28.7024 3.80188L29.9774 2.45996L30.4472 2.92975L28.7023 4.74148Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2852 16.4177C34.809 16.4177 33.6011 17.6256 33.6011 19.1018C33.6011 20.578 34.809 21.7859 36.2852 21.7859C37.7614 21.7859 38.9692 20.578 38.9692 19.1018C38.9692 17.6253 37.7617 16.4177 36.2852 16.4177ZM37.493 19.4373H36.6878V20.2426H36.0168V19.4373H35.2116V18.7664H36.0168V17.9611H36.6878V18.7664H37.493V19.4373Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0298 5.34567C36.5536 5.34567 35.3457 6.55355 35.3457 8.02975C35.3457 9.50595 36.5536 10.7138 38.0298 10.7138C39.506 10.7138 40.7139 9.50595 40.7139 8.02975C40.6467 6.55355 39.506 5.34567 38.0298 5.34567ZM39.1705 8.36529H38.3653V9.17056H37.6943V8.36529H36.889V7.69434H37.6943V6.88908H38.3653V7.69434H39.1705V8.36529Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.999 22.9264C22.7978 21.9869 22.3952 21.0475 21.8582 20.2423L23.0661 18.5646L20.6506 16.216L18.9729 17.4239C18.1676 16.8869 17.2952 16.5515 16.356 16.3503L16.0205 14.27H12.5983L12.2628 16.3503C11.3232 16.5515 10.5183 16.8872 9.71299 17.4239L7.96847 16.1489L5.55271 18.5646L6.82773 20.2423C6.29079 21.0476 5.95531 21.8529 5.75413 22.7921L3.67383 23.1276V26.5498L5.68699 26.8853C5.88815 27.8249 6.22394 28.7642 6.76059 29.5694L5.55271 31.18L7.96847 33.5957L9.51181 32.455C10.3842 32.9919 11.2563 33.3945 12.2631 33.6629L12.5314 35.6089L15.9533 35.6086L16.2217 33.7297C17.2281 33.5285 18.1677 33.1259 19.0401 32.5889L20.5834 33.7297L22.9992 31.3139L21.8585 29.7706C22.3954 28.8982 22.798 27.9589 22.9992 27.0193L24.9452 26.751V23.3287L22.999 22.9264ZM14.3432 31.3141C10.7867 31.3141 7.90137 28.4289 7.90137 24.8723C7.90137 21.3158 10.7866 18.4304 14.3432 18.4304C17.8997 18.4304 20.7851 21.3157 20.7851 24.8723C20.7851 28.4288 17.8998 31.3141 14.3432 31.3141Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5962 37.6892V41.6481L26.2199 39.6353L22.5962 37.6892Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49854 41.7821H21.9256V37.5546H7.49854V41.7821Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8271 37.5548H5.21653C4.07579 37.5548 3.13623 38.4944 3.13623 39.6351C3.13623 40.7759 4.07579 41.7154 5.21653 41.7154H6.8271V37.5548Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_20544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorprateConfig);
export default __webpack_public_path__ + "static/media/CorprateConfig.c661d230a63c7f1d028beeed40cc2eff.svg";
export { ForwardRef as ReactComponent };